// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__hzu47","calendarButtons":"ClockData_calendarButtons__kzU3j"};